import { Component, Element, Prop, h, Host, Watch } from '@stencil/core';
import * as colors from 'pn-design-assets/pn-assets/colors.js';
import type { PnColors } from '@/index';

/**
 * The `pn-icon` is a wrapper for an SVG string.
 * While its built with PostNords specific icon dimensions in mind (24x24px), you can use any SVG content in this component.
 * As long as its 3x3 in size, there should be no problem.
 *
 * The color feature will not overwrite the color of flags.
 **/
@Component({
  tag: 'pn-icon',
  styleUrl: 'pn-icon.scss',
})
export class PnIcon {
  @Element() hostElement: HTMLElement;

  /**
   * The SVG content of the icon you want to use.
   *
   * Flags cannot be colored.
   *
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-icon--docs|PostNord Icons (Storybook)}
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-flag--docs|PostNord Flags (Storybook)}
   **/
  @Prop() icon: string = '';
  /** Make the icon small (16 instead of 24px). */
  @Prop({ reflect: true }) small: boolean = false;
  /**
   * Color the icon with one of the follwing colors from our library.
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-colors--docs|PostNord Colors (Storybook)}
   **/
  @Prop() color?: PnColors = 'gray900';
  @Watch('color')
  handleColor() {
    const color = colors[this.color] || colors.gray900;
    this.hostElement.style.setProperty('--pn-icon-color', color);
  }

  componentWillLoad() {
    this.handleColor();
  }

  render() {
    return <Host role="presentation" class="pn-icon" innerHTML={this.icon}></Host>;
  }
}
